import CampusWhatWeOffer from "./CampusWhatWeOffer";
import ContactCam from "./contactCam";
import { useEffect } from "react";
import Placement from "./Placement";
import Corp from "./Copr_gif"

export default function NextgenPlacement(){
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div>
          <Placement/>
            <Corp/>
            <CampusWhatWeOffer/>
            <ContactCam/>       
        </div>
    )
}   